import { Route } from "react-router-dom";
import { MatchingListPage } from "pages/MatchingListPage";
import { MatchingPage } from "pages/MatchingPage";
import { matchingListPath, matchingPath } from "router/path";

export const MatchingRoutes = [
  <Route key={matchingPath} path={matchingPath} element={<MatchingPage />} />,
  <Route key={matchingListPath} path={matchingListPath} element={<MatchingListPage />} />,
];
